const cochegestAppHosts = new Set([
  "127.0.0.1",
  "localhost",
  "cochegest.test",
  "cochegest.com",
  "www.cochegest.com",
  "admin.cochegest.com",
  "sites.cochegest.com",
  "staging.cochegest.com",
  "admin-staging.cochegest.com",
  "sites-staging.cochegest.com",
]);

/**
 * Un dominio desconocido que llega al Worker solo puede ser un Custom Hostname
 * ya validado por el backend. La API vuelve a comprobar esa asociación antes
 * de devolver datos; esta función únicamente elige la experiencia visual.
 */
export function isDomainShowcaseHost(hostnameInput: string): boolean {
  const hostname = hostnameInput.trim().toLowerCase().replace(/\.$/, "");
  if (!hostname || cochegestAppHosts.has(hostname)) return false;
  if (hostname.endsWith(".workers.dev")) return false;
  return true;
}
